// extracted by mini-css-extract-plugin
module.exports = {"editBtn":"styles_editBtn__I94Hu","disableBtn":"styles_disableBtn__1_yfC","order_edit_btn":"styles_order_edit_btn__0Ge1b"};